import { screensInvestorsSharedOptions } from './screensInvestorsSharedOptions';
import { ViewOptionsService } from '../../../../../shared/entities/view/components/view/services/ViewOptionsService';
import { ViewColumnSystemName } from '../../../../../shared/entities/view/components/view-grid/enums/ViewColumnSystemName';
import { ScreenOptions } from '../../../shared/pages/interfaces/ScreenOptions';
import { ViewSummaryAlignType } from '../../../../../shared/entities/view/components/view/enums/ViewSummaryAlignType';

export const screensInvestorsInUseOptions: Partial<ScreenOptions> = ViewOptionsService.merge<ScreenOptions>(
  screensInvestorsSharedOptions,
  {
    summary: {
      align: ViewSummaryAlignType.Grid,
    },
    grid: {
      idCols: [ViewColumnSystemName.Id],
    },
  },
);
